import VerofreshRecord from './VerofreshRecord'
import { cloneDeep, remove, indexOf } from 'lodash'

class RouteAssessmentRecord extends VerofreshRecord {
  /**
   *
   * @param Array limitToContexts
   * @return Array
   */
  sortedNotes (limitToContexts = []) {
    if (this.notes === undefined) {
      return []
    }

    const sortedNotes = cloneDeep(this.notes)

    if (limitToContexts.length > 0) {
      remove(sortedNotes, (note) => {
        return indexOf(limitToContexts, note.context) === -1
      })
    }

    sortedNotes.sort(function (a, b) {
      if (a.created === b.created) {
        return 0
      }
      return a.created > b.created ? -1 : 1
    })

    return sortedNotes
  }
}

const relations = {
  hasMany: {
    Route: {
      foreignKey: 'id',
      localField: 'route'
    }
  }
}

export default RouteAssessmentRecord
export { relations }
